import { defineComponent as _defineComponent } from 'vue'
import { createElementVNode as _createElementVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, createVNode as _createVNode, withCtx as _withCtx, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-65d04983"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "follow-me" }
const _hoisted_2 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("h3", null, "Follow Me on", -1))
const _hoisted_3 = { class: "contact" }
const _hoisted_4 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("h3", null, "Kontakt", -1))
const _hoisted_5 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("p", null, "Daniel Daub", -1))
const _hoisted_6 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("p", null, "Elbestraße 50", -1))
const _hoisted_7 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("p", null, "65428 Rüsselsheim", -1))
const _hoisted_8 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("a", { href: "tel:00491724890833" }, "+49 172 4890833", -1))
const _hoisted_9 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("a", { href: "mailto:info@herrdaub.de" }, "info@herrdaub.de", -1))
const _hoisted_10 = ["src"]
const _hoisted_11 = { class: "legals" }
const _hoisted_12 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("p", null, "Copyright © 2022 Daniel Daub", -1))

import IconLink from '@/components/IconLink.vue';
  import ContactBox from '@/components/ContactBox.vue';
  import { nextTick, onMounted } from 'vue';

  
export default /*#__PURE__*/_defineComponent({
  __name: 'AppFooter',
  emits: ["rendered"],
  setup(__props, { emit }: { emit: ({
    (e: 'rendered', ): void;
  }), expose: any, slots: any, attrs: any }) {

  

  const contacts = {
    facebook: {label: 'Facebook', url: 'https://www.facebook.com/herrdaub', icon: 'facebook.svg'},
    instagram: {label: 'Instagram', url: 'https://www.instagram.com/herrdaub/', icon: 'instagram.svg'},
    youtube: {label: 'YouTube', url: 'https://www.youtube.com/Daniel%20Daub', icon: 'youtube.svg'},
  };

  // all elements loaded
  onMounted(() => {
    nextTick(() => {
      window.addEventListener('load', () => {
        emit('rendered');
      })
    })
  })



return (_ctx: any,_cache: any) => {
  const _component_router_link = _resolveComponent("router-link")!

  return (_openBlock(), _createElementBlock("footer", null, [
    _createElementVNode("article", null, [
      _createElementVNode("section", _hoisted_1, [
        _hoisted_2,
        _createElementVNode("ul", null, [
          (_openBlock(), _createElementBlock(_Fragment, null, _renderList(contacts, (contact, key) => {
            return _createElementVNode("li", { key: key }, [
              _createVNode(IconLink, {
                url: contact.url,
                icon: contact.icon,
                label: contact.label
              }, null, 8, ["url", "icon", "label"])
            ])
          }), 64))
        ])
      ]),
      _createElementVNode("section", _hoisted_3, [
        _hoisted_4,
        _createVNode(ContactBox, { icon: "locationDot.svg" }, {
          text: _withCtx(() => [
            _hoisted_5,
            _hoisted_6,
            _hoisted_7
          ]),
          _: 1
        }),
        _createVNode(ContactBox, { icon: "phone.svg" }, {
          text: _withCtx(() => [
            _hoisted_8
          ]),
          _: 1
        }),
        _createVNode(ContactBox, { icon: "envelope.svg" }, {
          text: _withCtx(() => [
            _hoisted_9
          ]),
          _: 1
        })
      ]),
      _createElementVNode("img", {
        class: "logo-orange",
        alt: "logo",
        src: require('@/assets/media/logos/logo_orange.png')
      }, null, 8, _hoisted_10)
    ]),
    _createElementVNode("article", _hoisted_11, [
      _createVNode(_component_router_link, { to: "/impressum" }, {
        default: _withCtx(() => [
          _createTextVNode("Impressum")
        ]),
        _: 1
      }),
      _createVNode(_component_router_link, { to: "/datenschutz" }, {
        default: _withCtx(() => [
          _createTextVNode("Datenschutz")
        ]),
        _: 1
      })
    ]),
    _hoisted_12
  ]))
}
}

})